import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { adObjectEntity } from './index';

/**
 * ADDomain entity - alias of ADObject
 * Represents Active Directory domain objects
 */
export const adDomainEntity: QueryEntity<unknown> = {
  ...adObjectEntity,
  primaryLabel: { actual: 'ADDomain', display: 'AD Domain' },
  alias: 'ADObject',
};
